import React from 'react';
import { CameraIcon, ClapperboardIcon, FilmIcon, GemIcon, HeartIcon, MicIcon, PlaneIcon, PlayIcon, SparklesIcon, SunIcon, UsersIcon } from 'lucide-react';
import { Experience } from '../data/experiences';
const map: Record<Experience['icon'], React.ComponentType<{
  size?: number;
  className?: string;
}>> = {
  sun: SunIcon,
  camera: CameraIcon,
  clapper: ClapperboardIcon,
  film: FilmIcon,
  heart: HeartIcon,
  rings: GemIcon,
  sparkles: SparklesIcon,
  plane: PlaneIcon,
  mic: MicIcon,
  play: PlayIcon,
  family: UsersIcon
};
export function ExperienceIcon({
  name,
  size = 20,
  className
}: {
  name: Experience['icon'];
  size?: number;
  className?: string;
}) {
  const Icon = map[name];
  return <Icon size={size} className={className} data-id="element-281" data-mp="pw7bzao8zo17" />;
}